import { createContext } from "react";

export interface ConfigurationContextState {
  projectId: string;
}

export const ConfigurationContext = createContext<ConfigurationContextState>({
  projectId: "",
});
